import React from 'react';
import { Link } from 'react-router-dom';

function Pricing() {
    return (
        <div className='container my-5'>
            <div className='row align-items-center'>
                {/* Left Column: Text */}
                {/*  */}

                {/* Right Column: Pricing Cards */}
               
            </div>
        </div>
    );
}

export default Pricing;